export default __webpack_public_path__ + "static/media/NewFooter.7aa5ae27.svg";